import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/restaurants/shifts.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getServmeShifts = (_0) => __async(void 0, [_0], function* ({ event_slug, lang }) {
  try {
    const lan = getLocaleOnly(lang);
    const url = `/servme/shifts?lang=${lan}&event_slug=${event_slug}`;
    const data = yield fetchClient({ url });
    if (data.status !== "success") {
      throw new Error((data == null ? void 0 : data.message) || "Something went wrong");
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getServmeShiftsException"
    });
  }
});

export {
  getServmeShifts
};
//# sourceMappingURL=chunk-NCW3PHK5.mjs.map